/**
 * Collapse dynamic URL segments (ids, uuids, tokens) into stable placeholders so
 * PostHog Paths / funnels group routes instead of fragmenting per record.
 *
 *   /reports/class/123                     -> /reports/class/:id
 *   /teacher/Bearer%20eyJhbGci...          -> /teacher/:token
 *   /surveys/9f1c2b3a-...-abcd/results     -> /surveys/:uuid/results
 *
 * @param {string} pathname e.g. window.location.pathname
 * @returns {string} normalized route pattern
 */
export const normalizePath = (pathname = '') => {
    if (!pathname || typeof pathname !== 'string') return pathname || '/';

    const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    const OBJECT_ID = /^[0-9a-f]{24}$/i; // mongo-style
    const NUMERIC = /^\d+$/;
    const TOKENISH = /^[A-Za-z0-9._%-]{20,}$/; // long opaque strings (jwt fragments, hashes)

    return (
        '/' +
        pathname
            .split('/')
            .filter(Boolean)
            .map((seg) => {
                const decoded = (() => {
                    try {
                        return decodeURIComponent(seg);
                    } catch (e) {
                        return seg;
                    }
                })();
                if (/^Bearer/i.test(decoded)) return ':token';
                if (UUID.test(seg)) return ':uuid';
                if (OBJECT_ID.test(seg)) return ':id';
                if (NUMERIC.test(seg)) return ':id';
                if (TOKENISH.test(seg)) return ':token';
                return seg;
            })
            .join('/')
    );
};

export default normalizePath;
